import React from 'react';
import { NavLink } from 'react-router-dom';

const Home = () => {
    const services = [
        {
            number: '01',
            icon: '📊',
            title: 'Finance & Accounting',
            description:
                'Outsource your accounting and finance operations to skilled professionals while keeping your business focused on growth.',
            items: [
                'Accounting & Bookkeeping',
                'Accounts Payable & Receivable',
                'R2R & General Ledger',
                'Reconciliation & MIS',
                'FP&A Support',
                'Virtual Accountants'
            ],
            link: '/service'
        },
        {
            number: '02',
            icon: '👥',
            title: 'Staffing & Payroll',
            description:
                'Get the professionals you need through flexible staffing and third-party payroll solutions designed around your business.',
            items: [
                'Finance Professionals',
                'IT Professionals',
                'Contract Staffing',
                'Third-Party Payroll',
                'Employee Administration',
                'Dedicated Professionals'
            ],
            link: '/service'
        },
        {
            number: '03',
            icon: '💻',
            title: 'IT & Technology',
            description:
                'Strengthen your technology capabilities with skilled IT professionals and practical software solutions for your business.',
            items: [
                'IT Staff Augmentation',
                'Dedicated Developers',
                'Backend & Frontend Development',
                'Web Applications',
                'API Development',
                'Technical Support'
            ],
            link: '/service'
        },
        {
            number: '04',
            icon: '⚙️',
            title: 'Business Process Outsourcing',
            description:
                'Outsource selected business processes or complete functions to dedicated Himsal teams and reduce operational complexity.',
            items: [
                'Finance Operations',
                'Accounting Operations',
                'Back-office Support',
                'Payroll Operations',
                'Managed Services',
                'Dedicated Teams'
            ],
            link: '/service'
        }
    ];

    const engagementModels = [
        {
            icon: '👤',
            title: 'Dedicated Professional',
            description:
                'Need one skilled professional? Get the right person for your specific business requirement.'
        },
        {
            icon: '👨‍💻',
            title: 'Dedicated Team',
            description:
                'Build a complete finance, accounting or technology team without managing every hiring requirement yourself.'
        },
        {
            icon: '🔄',
            title: 'Managed Services',
            description:
                'Outsource an entire process or function and let Himsal manage the day-to-day operations.'
        },
        {
            icon: '🚀',
            title: 'Project Based',
            description:
                'Have a specific website, software or business requirement? We can build a solution around your project.'
        }
    ];

    const industries = [
        'Startups & SMEs',
        'Technology Companies',
        'E-commerce',
        'Healthcare',
        'Education',
        'Manufacturing',
        'Professional Services',
        'Financial Services'
    ];

    const reasons = [
        {
            number: '01',
            title: 'Skilled Professionals',
            description:
                'Access capable finance, accounting and technology professionals based on your actual business requirements.'
        },
        {
            number: '02',
            title: 'Flexible Engagement',
            description:
                'Choose a dedicated professional, a complete team, a project-based engagement or a managed service.'
        },
        {
            number: '03',
            title: 'Cost-Effective Scaling',
            description:
                'Expand your capabilities without the cost and complexity of building every function entirely in-house.'
        },
        {
            number: '04',
            title: 'One Trusted Partner',
            description:
                'From people and payroll to finance operations and technology, Himsal brings multiple business needs together.'
        }
    ];

    return (
        <div
            style={{
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                backgroundColor: '#f8fafc',
                color: '#0f172a',
                overflowX: 'hidden'
            }}
        >

            {/* =========================================================
                HERO SECTION
            ========================================================= */}
            <section
                style={{
                    position: 'relative',
                    background:
                        'linear-gradient(135deg, #07162c 0%, #0b1f3a 55%, #12345b 100%)',
                    color: '#ffffff',
                    padding: '105px 20px 110px',
                    overflow: 'hidden'
                }}
            >
                {/* Decorative elements */}
                <div
                    style={{
                        position: 'absolute',
                        width: '420px',
                        height: '420px',
                        borderRadius: '50%',
                        background: 'rgba(59, 130, 246, 0.10)',
                        top: '-180px',
                        right: '-100px'
                    }}
                />

                <div
                    style={{
                        position: 'absolute',
                        width: '280px',
                        height: '280px',
                        borderRadius: '50%',
                        background: 'rgba(14, 165, 233, 0.08)',
                        bottom: '-140px',
                        left: '-100px'
                    }}
                />

                <div
                    style={{
                        maxWidth: '1180px',
                        margin: '0 auto',
                        position: 'relative',
                        zIndex: 2
                    }}
                >
                    <div
                        style={{
                            maxWidth: '850px',
                            margin: '0 auto',
                            textAlign: 'center'
                        }}
                    >
                        <div
                            style={{
                                display: 'inline-block',
                                padding: '8px 16px',
                                borderRadius: '50px',
                                backgroundColor: 'rgba(59, 130, 246, 0.14)',
                                border: '1px solid rgba(96, 165, 250, 0.25)',
                                color: '#93c5fd',
                                fontSize: '12px',
                                fontWeight: '700',
                                letterSpacing: '1.5px',
                                marginBottom: '24px'
                            }}
                        >
                            BUSINESS • STAFFING • TECHNOLOGY
                        </div>

                        <h1
                            style={{
                                fontSize: 'clamp(2.4rem, 6vw, 4.4rem)',
                                lineHeight: '1.08',
                                fontWeight: '800',
                                letterSpacing: '-1.8px',
                                margin: '0 0 26px',
                                color: '#ffffff'
                            }}
                        >
                            Build Your Team.
                            <br />
                            <span style={{ color: '#60a5fa' }}>
                                Outsource Your Operations.
                            </span>
                        </h1>

                        <p
                            style={{
                                maxWidth: '780px',
                                margin: '0 auto',
                                color: '#cbd5e1',
                                fontSize: 'clamp(1rem, 2vw, 1.18rem)',
                                lineHeight: '1.8'
                            }}
                        >
                            Himsal helps businesses scale with Finance & Accounting
                            Outsourcing, Professional Staffing, Third-Party Payroll,
                            IT Services and Business Process Outsourcing.
                        </p>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '14px',
                                flexWrap: 'wrap',
                                marginTop: '38px'
                            }}
                        >
                            <NavLink
                                to="/service"
                                style={{
                                    backgroundColor: '#3b82f6',
                                    color: '#ffffff',
                                    padding: '15px 28px',
                                    borderRadius: '8px',
                                    fontWeight: '700',
                                    textDecoration: 'none',
                                    boxShadow: '0 10px 30px rgba(59, 130, 246, 0.25)',
                                    display: 'inline-block'
                                }}
                            >
                                Explore Our Services →
                            </NavLink>

                            <NavLink
                                to="/contact"
                                style={{
                                    backgroundColor: 'transparent',
                                    color: '#ffffff',
                                    padding: '14px 28px',
                                    borderRadius: '8px',
                                    fontWeight: '700',
                                    textDecoration: 'none',
                                    border: '1px solid rgba(255,255,255,0.45)',
                                    display: 'inline-block'
                                }}
                            >
                                Talk to Us
                            </NavLink>
                        </div>
                    </div>

                    {/* Hero bottom stats */}
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns:
                                'repeat(auto-fit, minmax(180px, 1fr))',
                            gap: '1px',
                            marginTop: '75px',
                            backgroundColor: 'rgba(255,255,255,0.10)',
                            borderRadius: '12px',
                            overflow: 'hidden'
                        }}
                    >
                        {[
                            ['Finance', 'Accounting & Finance Services'],
                            ['Staffing', 'Professionals & Teams'],
                            ['Payroll', 'Third-Party Payroll'],
                            ['Technology', 'Web & IT Solutions']
                        ].map(([title, text]) => (
                            <div
                                key={title}
                                style={{
                                    padding: '22px 20px',
                                    backgroundColor: 'rgba(7, 22, 44, 0.65)',
                                    textAlign: 'center'
                                }}
                            >
                                <div
                                    style={{
                                        color: '#60a5fa',
                                        fontWeight: '800',
                                        fontSize: '16px',
                                        marginBottom: '5px'
                                    }}
                                >
                                    {title}
                                </div>

                                <div
                                    style={{
                                        color: '#94a3b8',
                                        fontSize: '12px'
                                    }}
                                >
                                    {text}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* =========================================================
                INTRODUCTION
            ========================================================= */}
            <section
                style={{
                    padding: '95px 20px',
                    backgroundColor: '#ffffff'
                }}
            >
                <div
                    style={{
                        maxWidth: '1180px',
                        margin: '0 auto',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '70px',
                        alignItems: 'center'
                    }}
                >
                    <div>
                        <div
                            style={{
                                color: '#2563eb',
                                fontSize: '13px',
                                fontWeight: '800',
                                letterSpacing: '1.5px',
                                textTransform: 'uppercase',
                                marginBottom: '12px'
                            }}
                        >
                            Who We Are
                        </div>

                        <h2
                            style={{
                                fontSize: 'clamp(2rem, 4vw, 3rem)',
                                lineHeight: '1.2',
                                margin: '0 0 22px',
                                color: '#0f172a',
                                fontWeight: '800',
                                letterSpacing: '-0.8px'
                            }}
                        >
                            Helping Businesses
                            <br />
                            <span style={{ color: '#2563eb' }}>
                                Build, Operate & Scale
                            </span>
                        </h2>

                        <p
                            style={{
                                color: '#475569',
                                fontSize: '16px',
                                lineHeight: '1.85',
                                marginBottom: '18px'
                            }}
                        >
                            Himsal Services helps businesses access skilled
                            professionals, outsource essential business functions
                            and build practical technology solutions without the
                            overhead of managing everything in-house.
                        </p>

                        <p
                            style={{
                                color: '#64748b',
                                fontSize: '15px',
                                lineHeight: '1.8'
                            }}
                        >
                            Whether you need an accountant, a dedicated technology
                            professional, a complete team, payroll support or an
                            outsourced business function, we provide flexible
                            engagement models built around your requirements.
                        </p>

                        <NavLink
                            to="/about"
                            style={{
                                display: 'inline-block',
                                marginTop: '15px',
                                color: '#2563eb',
                                fontWeight: '700',
                                textDecoration: 'none'
                            }}
                        >
                            Learn More About Himsal →
                        </NavLink>
                    </div>

                    {/* Right side highlight box */}
                    <div
                        style={{
                            background:
                                'linear-gradient(145deg, #f8fafc, #eef4fb)',
                            borderRadius: '18px',
                            padding: '35px',
                            border: '1px solid #e2e8f0'
                        }}
                    >
                        <div
                            style={{
                                color: '#0f172a',
                                fontWeight: '800',
                                fontSize: '20px',
                                marginBottom: '25px'
                            }}
                        >
                            One Partner. Multiple Business Needs.
                        </div>

                        {[
                            'Access skilled professionals',
                            'Outsource business operations',
                            'Build dedicated teams',
                            'Scale when your business grows'
                        ].map((item, index) => (
                            <div
                                key={item}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '14px',
                                    padding: '15px 0',
                                    borderBottom:
                                        index !== 3
                                            ? '1px solid #e2e8f0'
                                            : 'none'
                                }}
                            >
                                <span
                                    style={{
                                        width: '28px',
                                        height: '28px',
                                        borderRadius: '50%',
                                        backgroundColor: '#dbeafe',
                                        color: '#2563eb',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: '800',
                                        fontSize: '13px',
                                        flexShrink: 0
                                    }}
                                >
                                    ✓
                                </span>

                                <span
                                    style={{
                                        color: '#334155',
                                        fontSize: '14px',
                                        fontWeight: '600'
                                    }}
                                >
                                    {item}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* =========================================================
                SERVICES
            ========================================================= */}
            <section
                style={{
                    padding: '95px 20px',
                    backgroundColor: '#f8fafc'
                }}
            >
                <div
                    style={{
                        maxWidth: '1180px',
                        margin: '0 auto'
                    }}
                >
                    <div
                        style={{
                            maxWidth: '700px',
                            marginBottom: '55px'
                        }}
                    >
                        <div
                            style={{
                                color: '#2563eb',
                                fontSize: '13px',
                                fontWeight: '800',
                                letterSpacing: '1.5px',
                                textTransform: 'uppercase',
                                marginBottom: '12px'
                            }}
                        >
                            What We Do
                        </div>

                        <h2
                            style={{
                                fontSize: 'clamp(2rem, 4vw, 3rem)',
                                color: '#0f172a',
                                margin: '0 0 18px',
                                fontWeight: '800',
                                letterSpacing: '-0.8px'
                            }}
                        >
                            Services Built Around
                            <br />
                            <span style={{ color: '#2563eb' }}>
                                Your Business
                            </span>
                        </h2>

                        <p
                            style={{
                                color: '#64748b',
                                fontSize: '16px',
                                lineHeight: '1.8',
                                margin: 0
                            }}
                        >
                            Choose the support you need today and scale your
                            engagement as your business grows.
                        </p>
                    </div>

                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns:
                                'repeat(auto-fit, minmax(270px, 1fr))',
                            gap: '22px'
                        }}
                    >
                        {services.map((service) => (
                            <div
                                key={service.number}
                                style={{
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '14px',
                                    padding: '30px',
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '24px'
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px',
                                            backgroundColor: '#eff6ff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '23px'
                                        }}
                                    >
                                        {service.icon}
                                    </div>

                                    <span
                                        style={{
                                            color: '#cbd5e1',
                                            fontWeight: '800',
                                            fontSize: '14px'
                                        }}
                                    >
                                        {service.number}
                                    </span>
                                </div>

                                <h3
                                    style={{
                                        color: '#0f172a',
                                        fontSize: '20px',
                                        margin: '0 0 12px',
                                        fontWeight: '800'
                                    }}
                                >
                                    {service.title}
                                </h3>

                                <p
                                    style={{
                                        color: '#64748b',
                                        fontSize: '14px',
                                        lineHeight: '1.75',
                                        minHeight: '74px',
                                        marginBottom: '20px'
                                    }}
                                >
                                    {service.description}
                                </p>

                                <div
                                    style={{
                                        borderTop: '1px solid #e2e8f0',
                                        paddingTop: '18px'
                                    }}
                                >
                                    {service.items.slice(0, 4).map((item) => (
                                        <div
                                            key={item}
                                            style={{
                                                color: '#475569',
                                                fontSize: '13px',
                                                marginBottom: '9px'
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: '#2563eb',
                                                    fontWeight: '800',
                                                    marginRight: '8px'
                                                }}
                                            >
                                                ✓
                                            </span>
                                            {item}
                                        </div>
                                    ))}
                                </div>

                                <NavLink
                                    to={service.link}
                                    style={{
                                        display: 'inline-block',
                                        marginTop: '15px',
                                        color: '#2563eb',
                                        fontSize: '13px',
                                        fontWeight: '800',
                                        textDecoration: 'none'
                                    }}
                                >
                                    Explore Service →
                                </NavLink>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* =========================================================
                ENGAGEMENT MODELS
            ========================================================= */}
            <section
                style={{
                    padding: '95px 20px',
                    backgroundColor: '#ffffff'
                }}
            >
                <div
                    style={{
                        maxWidth: '1180px',
                        margin: '0 auto'
                    }}
                >
                    <div
                        style={{
                            textAlign: 'center',
                            maxWidth: '720px',
                            margin: '0 auto 55px'
                        }}
                    >
                        <div
                            style={{
                                color: '#2563eb',
                                fontSize: '13px',
                                fontWeight: '800',
                                letterSpacing: '1.5px',
                                textTransform: 'uppercase',
                                marginBottom: '12px'
                            }}
                        >
                            Flexible Engagement
                        </div>

                        <h2
                            style={{
                                fontSize: 'clamp(2rem, 4vw, 2.8rem)',
                                color: '#0f172a',
                                margin: '0 0 18px',
                                fontWeight: '800'
                            }}
                        >
                            Work With Us Your Way
                        </h2>

                        <p
                            style={{
                                color: '#64748b',
                                fontSize: '16px',
                                lineHeight: '1.8',
                                margin: 0
                            }}
                        >
                            Every business has different requirements. Choose
                            the engagement model that works best for you.
                        </p>
                    </div>

                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns:
                                'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: '20px'
                        }}
                    >
                        {engagementModels.map((model, index) => (
                            <div
                                key={model.title}
                                style={{
                                    padding: '30px',
                                    backgroundColor:
                                        index === 0 ? '#f8fafc' : '#ffffff',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '12px'
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '27px',
                                        marginBottom: '20px'
                                    }}
                                >
                                    {model.icon}
                                </div>

                                <h3
                                    style={{
                                        color: '#0f172a',
                                        fontSize: '18px',
                                        margin: '0 0 10px',
                                        fontWeight: '800'
                                    }}
                                >
                                    {model.title}
                                </h3>

                                <p
                                    style={{
                                        color: '#64748b',
                                        fontSize: '14px',
                                        lineHeight: '1.75',
                                        margin: 0
                                    }}
                                >
                                    {model.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* =========================================================
                WHY HIMSAL
            ========================================================= */}
            <section
                style={{
                    padding: '95px 20px',
                    backgroundColor: '#07162c',
                    color: '#ffffff'
                }}
            >
                <div
                    style={{
                        maxWidth: '1180px',
                        margin: '0 auto'
                    }}
                >
                    <div
                        style={{
                            maxWidth: '700px',
                            marginBottom: '55px'
                        }}
                    >
                        <div
                            style={{
                                color: '#60a5fa',
                                fontSize: '13px',
                                fontWeight: '800',
                                letterSpacing: '1.5px',
                                textTransform: 'uppercase',
                                marginBottom: '12px'
                            }}
                        >
                            Why Himsal
                        </div>

                        <h2
                            style={{
                                fontSize: 'clamp(2rem, 4vw, 3rem)',
                                color: '#ffffff',
                                margin: '0 0 18px',
                                fontWeight: '800',
                                lineHeight: '1.2'
                            }}
                        >
                            A Practical Partner
                            <br />
                            For Business Growth
                        </h2>

                        <p
                            style={{
                                color: '#94a3b8',
                                fontSize: '16px',
                                lineHeight: '1.8',
                                margin: 0
                            }}
                        >
                            We focus on understanding what your business
                            actually needs and building a solution around it.
                        </p>
                    </div>

                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns:
                                'repeat(auto-fit, minmax(260px, 1fr))',
                            gap: '25px'
                        }}
                    >
                        {reasons.map((reason) => (
                            <div
                                key={reason.number}
                                style={{
                                    borderTop: '1px solid rgba(255,255,255,0.15)',
                                    paddingTop: '25px'
                                }}
                            >
                                <div
                                    style={{
                                        color: '#60a5fa',
                                        fontSize: '13px',
                                        fontWeight: '800',
                                        marginBottom: '18px'
                                    }}
                                >
                                    {reason.number}
                                </div>

                                <h3
                                    style={{
                                        color: '#ffffff',
                                        fontSize: '19px',
                                        margin: '0 0 10px',
                                        fontWeight: '800'
                                    }}
                                >
                                    {reason.title}
                                </h3>

                                <p
                                    style={{
                                        color: '#94a3b8',
                                        fontSize: '14px',
                                        lineHeight: '1.75',
                                        margin: 0
                                    }}
                                >
                                    {reason.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* =========================================================
                INDUSTRIES
            ========================================================= */}
            <section
                style={{
                    padding: '90px 20px',
                    backgroundColor: '#f8fafc'
                }}
            >
                <div
                    style={{
                        maxWidth: '1000px',
                        margin: '0 auto',
                        textAlign: 'center'
                    }}
                >
                    <div
                        style={{
                            color: '#2563eb',
                            fontSize: '13px',
                            fontWeight: '800',
                            letterSpacing: '1.5px',
                            textTransform: 'uppercase',
                            marginBottom: '12px'
                        }}
                    >
                        Who We Serve
                    </div>

                    <h2
                        style={{
                            color: '#0f172a',
                            fontSize: 'clamp(2rem, 4vw, 2.8rem)',
                            margin: '0 0 18px',
                            fontWeight: '800'
                        }}
                    >
                        Supporting Businesses Across Industries
                    </h2>

                    <p
                        style={{
                            color: '#64748b',
                            fontSize: '16px',
                            lineHeight: '1.8',
                            maxWidth: '700px',
                            margin: '0 auto 40px'
                        }}
                    >
                        Our services can be adapted to the operational,
                        staffing and technology requirements of growing
                        businesses.
                    </p>

                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                            gap: '12px'
                        }}
                    >
                        {industries.map((industry) => (
                            <div
                                key={industry}
                                style={{
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '8px',
                                    padding: '13px 20px',
                                    color: '#334155',
                                    fontSize: '14px',
                                    fontWeight: '600'
                                }}
                            >
                                {industry}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* =========================================================
                FINAL CTA
            ========================================================= */}
            <section
                style={{
                    padding: '95px 20px',
                    backgroundColor: '#ffffff'
                }}
            >
                <div
                    style={{
                        maxWidth: '1050px',
                        margin: '0 auto',
                        background:
                            'linear-gradient(135deg, #0b1f3a 0%, #123b68 100%)',
                        borderRadius: '18px',
                        padding: '65px 35px',
                        textAlign: 'center',
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            width: '220px',
                            height: '220px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(96,165,250,0.08)',
                            right: '-80px',
                            top: '-100px'
                        }}
                    />

                    <div
                        style={{
                            position: 'relative',
                            zIndex: 2
                        }}
                    >
                        <div
                            style={{
                                color: '#93c5fd',
                                fontSize: '12px',
                                fontWeight: '800',
                                letterSpacing: '1.5px',
                                marginBottom: '15px'
                            }}
                        >
                            LET'S WORK TOGETHER
                        </div>

                        <h2
                            style={{
                                color: '#ffffff',
                                fontSize: 'clamp(2rem, 4vw, 3rem)',
                                lineHeight: '1.2',
                                margin: '0 0 18px',
                                fontWeight: '800'
                            }}
                        >
                            Have a Business Requirement?
                        </h2>

                        <p
                            style={{
                                color: '#cbd5e1',
                                fontSize: '16px',
                                lineHeight: '1.8',
                                maxWidth: '650px',
                                margin: '0 auto'
                            }}
                        >
                            Tell us what you need — whether it is a professional,
                            a dedicated team, an outsourced function or a
                            technology solution. We will help you find the right
                            approach.
                        </p>

                        <NavLink
                            to="/contact"
                            style={{
                                display: 'inline-block',
                                marginTop: '30px',
                                backgroundColor: '#ffffff',
                                color: '#0b1f3a',
                                padding: '15px 30px',
                                borderRadius: '8px',
                                fontWeight: '800',
                                textDecoration: 'none'
                            }}
                        >
                            Start a Conversation →
                        </NavLink>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
